module.exports = __webpack_public_path__ + "static/legacy_honor_bgM@2x-8e5125fbe90e4e28114c9a0f6e17365e.jpg";